export const MIN_LENGTH = 0;
export const MAX_LENGTH = 1000;
export const DEFAULT_COLS = 50;
export const DEFAULT_ROWS = 5;
